var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32428 7.08525L7.56699 3.84255L7.03991 3.32692L4.32428 6.04255L2.94928 4.66755L2.43366 5.18317L4.32428 7.08525ZM5.00033 9.58317C4.37394 9.58317 3.78192 9.46286 3.22428 9.22223C2.66665 8.98161 2.17967 8.65314 1.76335 8.23682C1.34703 7.8205 1.01855 7.33352 0.77793 6.77588C0.537305 6.21824 0.416992 5.62623 0.416992 4.99984C0.416992 4.36581 0.537305 3.76998 0.77793 3.21234C1.01855 2.6547 1.34703 2.16963 1.76335 1.75713C2.17967 1.34463 2.66665 1.01807 3.22428 0.777441C3.78192 0.536816 4.37394 0.416504 5.00033 0.416504C5.63435 0.416504 6.23019 0.536816 6.78783 0.777441C7.34547 1.01807 7.83054 1.34463 8.24304 1.75713C8.65554 2.16963 8.9821 2.6547 9.22272 3.21234C9.46335 3.76998 9.58366 4.36581 9.58366 4.99984C9.58366 5.62623 9.46335 6.21824 9.22272 6.77588C8.9821 7.33352 8.65554 7.8205 8.24304 8.23682C7.83054 8.65314 7.34547 8.98161 6.78783 9.22223C6.23019 9.46286 5.63435 9.58317 5.00033 9.58317Z",
    fill: "#33CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a1000e3bc944bc43158c29f7e4337d42.svg";
export { ForwardRef as ReactComponent };